import { paths } from 'src/routes/paths';

export const NODE_ENV = import.meta.env.VITE_NODE_ENV
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const API_URL = import.meta.env.VITE_API_URL;
export const ASSETS_API_URL = import.meta.env.VITE_ASSETS_API_URL;
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;
// export const IS_PRODUCTION = import.meta.env.PROD;
export const CUSTOM_TRAIL_ID = import.meta.env.VITE_CUSTOM_TRAIL_ID;
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const PATH_AFTER_LOGIN = paths.root;
